import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["teamDropdown"]
  static values = {
    teams: Object, // { teamId: { name: "Team A", employeeIds: [1, 2, 3] } }
    selectId: String, // ID of the select element to control
  }

  get selectElement() {
    return document.getElementById(this.selectIdValue)
  }

  get selectController() {
    const select = this.selectElement
    if (!select) return null
    return this.application.getControllerForElementAndIdentifier(select, "select")
  }

  selectAll() {
    const select = this.selectElement
    const selectController = this.selectController
    if (!select || !selectController || !selectController.slimselect) return

    const allValues = Array.from(select.options)
      .filter((opt) => opt.value)
      .map((opt) => opt.value)
    selectController.slimselect.setSelected(allValues)
  }

  selectTeam(event) {
    const teamId = event.currentTarget.dataset.teamId
    const teamData = this.teamsValue[teamId]
    if (!teamData) return

    const select = this.selectElement
    const selectController = this.selectController
    if (!select || !selectController || !selectController.slimselect) return

    const availableIds = new Set(Array.from(select.options).map((opt) => opt.value))
    const idsToSelect = teamData.employeeIds.map(String).filter((id) => availableIds.has(id))
    selectController.slimselect.setSelected(idsToSelect)

    // Close the dropdown menu
    if (this.hasTeamDropdownTarget) {
      this.teamDropdownTarget.classList.add("hidden")
    }
  }

  clearSelection() {
    const selectController = this.selectController
    if (!selectController || !selectController.slimselect) return

    selectController.slimselect.setSelected([])
  }

  toggleTeamDropdown() {
    if (this.hasTeamDropdownTarget) {
      this.teamDropdownTarget.classList.toggle("hidden")
    }
  }

  closeTeamDropdown(event) {
    // Close dropdown if clicking outside
    if (this.hasTeamDropdownTarget && !this.element.contains(event.target)) {
      this.teamDropdownTarget.classList.add("hidden")
    }
  }

  connect() {
    // Close dropdown when clicking outside
    this.boundCloseTeamDropdown = this.closeTeamDropdown.bind(this)
    document.addEventListener("click", this.boundCloseTeamDropdown)
  }

  disconnect() {
    document.removeEventListener("click", this.boundCloseTeamDropdown)
  }
}
